import React from 'react';
const stats = [{
  value: '500+',
  label: 'coaches served'
}, {
  value: '6 + 5',
  label: 'tomes + bonuses'
}, {
  value: '4.9/5',
  label: 'rating'
}, {
  value: '🌎',
  label: 'coaches worldwide'
}];
export function SocialProofBar() {
  return <section aria-label="Social proof" className="w-full bg-sage text-white" data-id="element-185" data-mp="29up7k8zgxqty">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-7" data-id="element-186" data-mp="25u59n372mj6r">
        <ul className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-white/15" data-id="element-187" data-mp="32iuwz91gw404">
          {stats.map(stat => <li key={stat.label} className="flex flex-col items-center justify-center text-center py-3 md:py-0 px-2" data-id="element-188" data-mp="2xkjl6srm3jf9">
              <span className="font-serif font-bold text-2xl sm:text-3xl leading-none" data-id="element-189" data-mp="2ojv6rwyb3h1u">
                {stat.value}
              </span>
              <span className="mt-1.5 text-[11px] sm:text-xs uppercase tracking-[0.14em] text-white/75" data-id="element-190" data-mp="1i4ujsgr9e97e">
                {stat.label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}